// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__urIUB","rootSmall":"AddTileButton_rootSmall__a4T8L"};